import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

const users = {
  data: [
    {
      id: "c3b2b1e9-d7e9-43e3-b03f-c5b18b4a9e9e",
      avatar: "",
      name: "Charlotte Zhuang",
      username: "Charlotte",
      email: "Charlotte.Zhuang@mail.com",
      orgRoleName: "Viewer",
      orgRoleId: 7,
      siteAccesses: [
        {
          siteName: "Taipei",
          siteId: "9f0a2cce-45b8-46a4-b4cf-7e6eaa7d4e0f",
          siteRoleName: "Viewer",
          siteRoleId: 10,
        },
      ],
      status: "inactive",
      timeOfAuth: 1736356148,
      lastLoginTime: 1736312346,
    },
    {
      id: "c3b2b1e9-d7e9-43e3-b03f-c5b18b4a9123",
      avatar: "",
      username: "user2",
      email: "user003@mail.com",
      orgRoleName: "Viewer",
      orgRoleId: 7,
      siteAccesses: [
        {
          siteName: "Taipei",
          siteId: "9f0a2cce-45b8-46a4-b4cf-7e6eaa7d4e0f",
          siteRoleName: "Viewer",
          siteRoleId: 10,
        },
        {
          siteName: "Kaohsiung",
          siteId: "1d37f278-6b7a-4b65-88ab-bbb21e03fae1",
          siteRoleName: "Admin",
          siteRoleId: 9,
        },
      ],
      status: "active",
      timeOfAuth: 1736399854,
      lastLoginTime: 1736367841,
    },
    {
      id: "c300b1e9-d7e9-43e3-b03f-c5b18b4a9e9e",
      avatar: "",
      name: "Amy",
      username: "user3",
      email: "fgsfsf333@mail.com",
      orgRoleName: "Super Admin",
      orgRoleId: 5,
      siteAccesses: [],
      status: "active",
      timeOfAuth: 1736354321,
      lastLoginTime: 1736356723,
    },
    {
      id: "a3b2b1e9-d7e9-43e3-633f-c5b18b4a9e9e",
      avatar: "",
      name: "Jack",
      username: "aa1",
      email: "12321dfa@mail.com",
      orgRoleName: "Admin",
      orgRoleId: 6,
      siteAccesses: [],
      status: "active",
      timeOfAuth: 1736312345,
      lastLoginTime: 1736356143,
    },
  ],
};

const orgRoleMap = {
  5: "Super Admin",
  6: "Admin",
  7: "Viewer",
};

const siteRoleMap = {
  9: "Admin",
  10: "Viewer",
};

const siteMap = {
  "1d37f278-6b7a-4b65-88ab-bbb21e03fae1": "Kaohsiung",
  "9f0a2cce-45b8-46a4-b4cf-7e6eaa7d4e0f": "Taipei",
};

export const onPremUserManagementSlice = createSlice({
  name: "onPremUserManagement",
  initialState: {
    users,
  },
  reducers: {
    setUser: (state, action) => {
      state.users.data = action.payload;
    },
    addUser: (state, action) => {
      const newUser = {
        id: uuidv4(),
        timeOfAuth: Math.floor(Date.now() / 1000),
        lastLoginTime: null,
        ...action.payload,
      };
      state.users.data.push(newUser);
    },
    removeUser: (state, action) => {
      const userId = action.payload;
      state.users.data = state.users.data.filter((user) => user.id !== userId);
    },
    updateUser: (state, action) => {
      const { userId, updates } = action.payload;

      const userIndex = state.users.data.findIndex(
        (user) => user.id === userId
      );

      if (userIndex !== -1) {
        let updatedUser = {
          ...state.users.data[userIndex],
          ...updates,
        };

       if (updates.accountStatus !== undefined) {
          updatedUser.status = updates.accountStatus ? "active" : "inactive";
          updatedUser.accountStatus = updates.accountStatus;
        }

        if (updates.orgRoleId !== undefined) {
          updatedUser.orgRoleName = orgRoleMap[updates.orgRoleId] || "Viewer";
        }

        if (updates.siteAccesses) {
          updatedUser.siteAccesses = updates.siteAccesses.map((site) => {
            let siteId = site.siteId;

            if (siteId.includes("_ID")) {
              const baseName = siteId.replace("_ID", "");
              const foundUUID = Object.keys(siteMap).find(
                (uuid) => siteMap[uuid] === baseName
              );
              if (foundUUID) {
                siteId = foundUUID;
              }
            }

            return {
              ...site,
              siteId,
              siteName: siteMap[siteId] || "Unknown Site",
              siteRoleName: siteRoleMap[site.siteRoleId] || "Viewer",
            };
          });
        }

        state.users.data[userIndex] = updatedUser;
      }
    },
  },
});

export const { setUser, addUser, removeUser, updateUser } =
  onPremUserManagementSlice.actions;

export default onPremUserManagementSlice.reducer;
